import { createAction, createReducer } from '@reduxjs/toolkit'
import basicAxios from 'axios'

import { createAppAsyncThunk } from '@/redux/utils'
import { axios as axiosUtil, requestBaeApi } from '@/utils/axios'
import { getBaeApiBaseUrl } from '@/utils/env'

const namespace = 'sendPost'
const axios = basicAxios.create()

export interface UploadImgParams {
  imgFiles: File[]
  user_id: number
  user_name: string
  token: string
}

export interface UploadImgByApiKeyParams {
  imgFiles: string[]
  files?: File[]
}

export interface UploadBlobImgByApiKeyParams {
  imgBase64: string
  fileName: string
}

export interface UploadVideoParams {
  videoFile: File
  user_id: number
  user_name: string
  token: string
}

export const uploadVideo = createAppAsyncThunk(
  `${namespace}/uploadVideo`,
  async (data: UploadVideoParams): Promise<string> => {
    const token = data.token
    if (token === '') {
      throw new Error('Unauthorized')
    }
    const getPostreqUrl = `${getBaeApiBaseUrl()}/api/v1/postreq`
    let postreqUrl: string = ''
    await axios
      .get(getPostreqUrl, {
        headers: {
          Authorization: token,
        },
      })
      .then((res: { data: string }) => {
        postreqUrl = res.data
      })
    const id = postreqUrl.split('/').pop()
    let videoUrl:
      | string
      | null = `https://customer-sn5y0tm58c41dbpc.cloudflarestream.com/${id}/manifest/video.m3u8`
    const formData = new FormData()
    formData.append('file', data.videoFile)
    formData.append('name', data.videoFile.name)
    formData.append('type', 'bae')
    formData.append(
      'meta',
      JSON.stringify({
        name: data.videoFile.name,
        type: 'bae',
      }),
    )
    await axios
      .post(postreqUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(async () => {
        let isNotFound = true
        while (isNotFound && videoUrl) {
          try {
            await axios.get(videoUrl)
            isNotFound = false
          } catch (err) {
            console.error(err)
            await new Promise((resolve) => setTimeout(resolve, 3000))
          }
        }
      })
      .catch((e) => {
        console.error(e)
        videoUrl = null
      })
    return videoUrl
  },
)

export interface SendPostParams {
  creatorId: number
  media: string
  title?: string
  type: number
  currency: number
  price: number
  userid: number
  width: string
  height: string
  // token: string
  cover?: string
  needUpload?: boolean
}

interface SendPostResponse {
  pid: number
}

export const sendToPost = createAppAsyncThunk(
  `${namespace}/sendPost`,
  async (data: SendPostParams) => {
    if (data.type === 0) {
      data.media = data.cover + ',' + data.media
    }
    const result = await requestBaeApi<SendPostResponse>({
      creatorId: data.creatorId,
      url: '/co/v1/post',
      method: 'post',
      data,
    })
    void axiosUtil.post('/post/postEmployee/relation/add', {
      postId: result.data.pid,
      creatorId: data.creatorId,
      price: data.price,
      createdAt: new Date().toISOString(),
    })
  },
)

export const getPostLink = createAppAsyncThunk(
  `${namespace}/getPostLink`,
  async (data: { uid: number; pid: number, creatorId: number }) => {
    const response = await requestBaeApi<{ ref: string } | undefined>({
      creatorId: data.creatorId,
      url: '/co/v1/link',
      method: 'post',
      data,
    })
    return response.data
  },
)

export const resetPostSendSuccess = createAction('resetPostSendSuccess')

const initialState: {
  sendingLoading: boolean
  sendSuccess: boolean | undefined
  sendFail: boolean
} = {
  sendingLoading: false,
  sendSuccess: undefined,
  sendFail: false,
}
const reducer = createReducer(initialState, (builder) => {
  builder.addCase(resetPostSendSuccess, (draft) => {
    draft.sendSuccess = undefined
    draft.sendFail = false
  })

  builder.addCase(sendToPost.pending, (draft) => {
    draft.sendingLoading = true
    draft.sendFail = false
  })
  builder.addCase(sendToPost.fulfilled, (draft) => {
    draft.sendingLoading = false
    draft.sendFail = false
    draft.sendSuccess = !draft.sendSuccess
  })
  builder.addCase(sendToPost.rejected, (draft) => {
    draft.sendingLoading = false
    draft.sendFail = true
    draft.sendSuccess = undefined
  })
})

export default { [namespace]: reducer }
